module.exports = __webpack_public_path__ + "media/smile.37597d74.mp3";